<template>
  <div v-if="engraving" class="product-rengraving">
    <ModalAsideHeader>
      <DefTitle :result="2">
        <h2>{{ engraving?.name }}</h2>
      </DefTitle>
    </ModalAsideHeader>
    <div v-if="font?.items" class="product-rengraving-block">
      <DefTitle :result="4">
        <h4>{{ font?.name }}</h4>
      </DefTitle>
      <div class="product-rengraving-items">
        <div v-for="item in font?.items" class="product-rengraving-item">
          <VueMagnifier :src="item?.picture.src" :alt="item?.picture.alt" />
          <DefRadio name="font" @change="selectedFont = item">
            <!--          <DefImg v-if="item?.picture" :result="item?.picture" max-width="100px" />-->
            {{ item?.UF_NAME }}
          </DefRadio>
        </div>
      </div>
    </div>

    <!--    <DefTitle :result="5">-->
    <!--      <h5>{{ font?.place }}</h5>-->
    <!--    </DefTitle>-->
    <div v-if="place?.items" class="product-rengraving-block">
      <DefTitle :result="4">
        <h4>{{ place?.name }}</h4>
      </DefTitle>
      <div class="product-rengraving-items">
        <div v-for="item in place?.items" class="product-rengraving-item">
          <VueMagnifier :src="item?.picture.src" :alt="item?.picture.alt" />
          <DefRadio
            name="place"
            @change="
              selectedPlace = item;
              text = '';
            "
          >
            <!--          <DefImg v-if="item?.picture" :result="item?.picture" max-width="100px" />-->
            {{ item?.UF_NAME }}
          </DefRadio>
        </div>
      </div>
    </div>

    <div v-if="isTextActive" class="product-rengraving-block">
      <div class="rengraving-input-header">
        <DefTitle :result="4">
          <h4>
            {{ messages?.engravingText }}
          </h4>
        </DefTitle>
        <p>
          {{ messages?.characterCount }}
          <span v-if="symbolsLeft !== null">{{ symbolsLeft }} / </span>
          {{ selectedPlace?.UF_CHARACTERS_LIMIT }}
        </p>
      </div>
      <DefTextarea
        :placeholder="messages?.engravingTextPlaceholder"
        :maxlength="selectedPlace?.UF_CHARACTERS_LIMIT"
        :readonly="!selectedPlace?.UF_CHARACTERS_LIMIT"
        :value="text"
        @input="text = $event.target.value"
      ></DefTextarea>
    </div>

    <DefButtonPrimary :disabled="!isShowSendButton" @click="handlerSubmit">
      {{ createOrder.name }}
    </DefButtonPrimary>
  </div>
</template>

<script lang="ts" setup>
import ModalAsideHeader from '@use/useModalAside/ModalAsideHeader.vue';
import { useStore } from '@/store';
import { computed, ref } from 'vue';
import DefRadio from '@components/Def/DefRadio/DefRadio.vue';
import DefTitle from '@components/Def/DefTitle/DefTitle.vue';
import DefTextarea from '@components/Def/DefTextarea/DefTextarea.vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import axios from 'axios';
import VueMagnifier from '@websitebeaver/vue-magnifier';
import '@websitebeaver/vue-magnifier/styles.css';

const { state } = useStore();

const engraving = computed(() => state?.product?.data?.product?.engraving?.[0]);
const product = computed(() => state?.product?.data?.product);
const messages = computed(() => state?.product?.data?.messages);
const font = computed(() => engraving.value?.font);
const place = computed(() => engraving.value?.place);
const createOrder = computed(() => state.basket.data?.routes?.createOrder);

const selectedFont = ref(null);
const selectedPlace = ref(null);
const text = ref(null);

const symbolsLeft = computed(() => {
  if (selectedPlace.value?.UF_CHARACTERS_LIMIT) {
    return +selectedPlace.value?.UF_CHARACTERS_LIMIT - (text.value?.length ?? 0);
  }
  return null;
});

const isTextActive = computed(() => {
  if (place.value?.items?.length > 0 && +selectedPlace.value?.UF_CHARACTERS_LIMIT > 0) {
    return true;
  }

  return false;
});

const isShowSendButton = computed(() => {
  if (isTextActive.value && !text.value) {
    return false;
  }

  if (font.value?.items?.length > 0 && !selectedFont.value) {
    return false;
  }

  if (place.value?.items?.length > 0 && !selectedPlace.value) {
    return false;
  }

  return true;
});

const propsString = computed(() => {
  let str = '';

  if (isTextActive.value && text?.value) {
    str += `${messages.value?.engraving} - ${text?.value}`;
    if (selectedFont?.value?.UF_NAME || selectedPlace?.value?.UF_NAME) {
      str += ', ';
    }
  }

  if (font?.value?.items?.length > 0 && selectedFont?.value?.UF_NAME) {
    str += `${font?.value?.checkoutName} - ${selectedFont?.value?.UF_NAME}`;
    if (selectedPlace?.value?.UF_NAME) {
      str += ', ';
    }
  }

  if (place?.value?.items?.length > 0 && selectedPlace?.value?.UF_NAME) {
    str += `${place?.value?.checkoutName} - ${selectedPlace?.value?.UF_NAME}`;
  }

  return str;
});

const handlerSubmit = async () => {
  try {
    const { status, data } = await axios.post('/ajax/', {
      action: 'createEngravingOrder',
      productId: product.value?.offer?.id || product.value?.id,
    });

    if (data?.pathToCheckout) {
      window.sessionStorage.setItem('engraving', propsString.value);

      window.location.href = createOrder.value.path;
    }

    // createEngravingOrder action
    // like ipost name
    // UF_NAME name value
  } catch (err) {
    console.error(err);
  }
};
// createOrder.path
</script>

<style lang="scss" scoped>
.product-rengraving {
  :deep(.def-radio) {
    flex-direction: column-reverse;
    align-items: center;
  }
  :deep(.def-radio__text) {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 16px;
  }
  :deep(.def-button-primary) {
    width: 100%;
    @include point-md {
      width: unset;
    }
    //margin-bottom: 16px;
  }
  :deep(.modal-aside-header) {
    margin-bottom: 16px;
  }
}
.product-rengraving-block {
  margin-bottom: 36px;
}
.rengraving-input-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  :deep(.def-title) {
    margin-bottom: 0;
  }
}
.product-rengraving-items {
  display: flex;
  flex-wrap: wrap;
}
.product-rengraving-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 150px;
  :deep(.vue-magnifier__magnifier) {
    margin-bottom: 16px;
  }
}
</style>
